import React from 'react';

import { Content } from './Content.js';
import LargeIconListPanelCol from './LargeIconListPanelCol.jsx';
import { Utils } from './../../utils/Utils.js';

export default class LargeIconListPanel extends React.Component {

  render() {
    const lastClass = (this.props.isLast === true) ? 'last' : '';
    const pipeClass = (this.props.noPipes === true) ? 'nopipes' : '';
    const icons = Content[this.props.page][this.props.section].icons;

    return (
      <div className={`LargeIconListPanel row ${lastClass} ${this.props.section} ${pipeClass}`}>
        <div className="col-xs-16">
          <div className="fake-void left"></div>
          <div className="fake-void right"></div>
          <div className="inner">
            <div className="container-fluid">
              <div className="row items-row">
                {
                  icons.map((icon, index) => (
                    <LargeIconListPanelCol key={ index } icon={ icon } />
                  ))
                }
              </div>
            </div>
          </div>
          <div className="stroke vertical left"></div>
          <div className="stroke vertical right"></div>
        </div>
      </div>
    );
  }

};
